import {
	MDX_ATTRIBUTES_SOURCE,
	mintlifyIconHtml,
	readMdxAttributes,
} from "@productlane/lib/src/tiptap/extensions/mintlify/icon-html"

const ICON = new RegExp(`<Icon${MDX_ATTRIBUTES_SOURCE}/?>(?:</Icon>)?`, "g")

/** marked leaves an inline `<Icon />` as raw HTML; this turns it into ours. */
export function renderIconInline(html: string): string {
	return html.replace(ICON, (_whole, attributes: string) => {
		const a = readMdxAttributes(attributes ?? "")
		return mintlifyIconHtml(a.icon, { size: a.size, color: a.color })
	})
}
